class ServiceInfo {
  constructor() {
    this.serviceButtons = document.querySelectorAll('.service-info-button');
    this.modal = document.getElementById('serviceModal');
    this.modalTabs = document.querySelectorAll('.service-modal-tab');
    this.modalClose = document.querySelector('.service-modal-close');
    this.modalOverlay = document.querySelector('.service-modal-overlay');
    this.contentPanels = document.querySelectorAll('.service-info-content-panel, .service-modal-content-panel');
    this.modalTitle = document.getElementById('serviceModalTitle');
    
    this.init();
  }

  init() {
    console.log('ServiceInfo initialized'); // Debug log
    console.log('Found service buttons:', this.serviceButtons.length); // Debug log
    console.log('Found content panels:', this.contentPanels.length); // Debug log
    
    this.serviceButtons.forEach((button, index) => {
      const serviceId = button.getAttribute('data-service-id');
      console.log(`Button ${index}:`, serviceId, button); // Debug log
      
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const serviceId = button.getAttribute('data-service-id');
        console.log('Button clicked:', serviceId); // Debug log
        
        if (document.querySelector('.service-info-content')) {
          this.switchContent(serviceId);
        } else {
          this.openModal(serviceId);
        }
      });
    });

    if (this.modal) {
      this.modalTabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const serviceId = tab.getAttribute('data-service-id');
          this.switchTab(serviceId);
        });
      });

      this.modalClose.addEventListener('click', () => {
        this.closeModal();
      });

      this.modalOverlay.addEventListener('click', () => {
        this.closeModal();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('show')) {
          this.closeModal();
        }
      });

      this.modal.querySelector('.service-modal-content').addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  switchContent(serviceId) {
    console.log('Switching to service:', serviceId); // Debug log
    
    this.serviceButtons.forEach(button => {
      button.classList.remove('service-info-button--active');
    });

    this.contentPanels.forEach(panel => {
      panel.classList.remove('service-info-content-panel--active');
    });

    const targetButton = document.querySelector(`.service-info-button[data-service-id="${serviceId}"]`);
    if (targetButton) {
      targetButton.classList.add('service-info-button--active');
      console.log('Activated button:', targetButton); // Debug log
    }

    let targetPanelId;
    if (serviceId === 'service-judgeme') {
      targetPanelId = 'service-content-judgeme';
    } else {
      targetPanelId = `service-content-${serviceId.replace('service-', '')}`;
    }

    const targetPanel = document.getElementById(targetPanelId);
    if (targetPanel) {
      targetPanel.classList.add('service-info-content-panel--active');
      console.log('Activated panel:', targetPanel); // Debug log
    } else {
      console.warn('Target panel not found:', targetPanelId); // Debug log
    }
  }

  openModal(serviceId) {
    this.switchTab(serviceId);

    this.modal.classList.add('show');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      this.modal.style.opacity = '1';
    }, 10);
  }

  switchTab(serviceId) {
    this.modalTabs.forEach(tab => {
      tab.classList.remove('service-modal-tab--active');
    });

    this.contentPanels.forEach(panel => {
      panel.classList.remove('service-modal-content-panel--active');
    });

    const targetTab = document.querySelector(`.service-modal-tab[data-service-id="${serviceId}"]`);
    const targetPanel = document.getElementById(`service-content-${serviceId.replace('service-', '')}`);

    if (targetTab) {
      targetTab.classList.add('service-modal-tab--active');
    }

    if (targetPanel) {
      targetPanel.classList.add('service-modal-content-panel--active');
    }

    if (this.modalTitle && targetTab) {
      this.modalTitle.textContent = targetTab.textContent.trim();
    }
  }

  closeModal() {
    this.modal.style.opacity = '0';
    
    setTimeout(() => {
      this.modal.classList.remove('show');
      document.body.style.overflow = '';
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.service-info-section')) {
    new ServiceInfo();
  }
});

if (typeof window !== 'undefined') {
  window.ServiceInfo = ServiceInfo;
} 